export default "__VITE_ASSET__CDdyoGJ3__"